gsap.registerPlugin(ScrollTrigger);
// Splitting({
//     target: '.typingText'
// });

$(document).ready(function () {
  function SetTypingText(wrapper, elements, lineindex, linelength) {
    let titileTimeLine = gsap.timeline({
      scrollTrigger: {
        // markers: true,
        trigger: wrapper,
        start: 'top top+=80%',
        end: 'bottom +=10%',
      },
    });
    var linetime = 0.6;
    var peratime = 0.6;
    var letters = $(elements).find('span.char, span.whitespace');
    var stagTime = Math.round((linetime / letters.length) * 100) / 100;
    var gapTime = Math.round((peratime / linelength) * 100) / 100;
    titileTimeLine.to(
      letters,
      {
        opacity: 1,
        stagger: stagTime,
      },
      lineindex * gapTime
    );
  }

  $('.typingText').each(function () {
    const results = Splitting({
      target: $(this),
      by: 'lines',
    });
    var wrapper = $(this).data('wrapper') ? $(this).closest($(this).data('wrapper')) : $(this).parent();
    results[0].lines.forEach((line, index, lines) => {
      Splitting({
        target: $(line),
      });
      SetTypingText(wrapper, line, index, lines.length);
    });
  });

  function SetFloatingText(wrapper, elements, lineindex, stagTime) {
    // console.log(wrapper, element)
    // var lineindex=index;
    let titileTimeLine = gsap.timeline({
      scrollTrigger: {
        // markers: true,
        trigger: wrapper,
        start: 'top top+=80%',
        end: 'bottom +=10%',
      },
    });
    elements.forEach((element) => {
      titileTimeLine.fromTo(
        element,
        {
          y: '10px',
          opacity: 0,
        },
        {
          y: '0px',
          opacity: 1,
          duration: 0.3,
        },
        lineindex * stagTime
      );
    });
  }

  $('.float-text').each(function (elindex) {
    var wrapper = $(this).data('wrapper') ? $(this).data('wrapper') : $(this).parent();
    var time = $(this).data('time') ? $(this).data('time') : 0.6;
    const results = Splitting({
      target: $(this),
      by: 'lines',
    });

    var stagTime = Math.round((time / results[0].lines.length) * 100) / 100;
    // console.log(elindex, stagTime, this)
    results[0].lines.forEach((line, index) => {
      SetFloatingText(wrapper, line, index, stagTime);
    });
  });

  function SetFloatingBox(wrapper) {
    let titileTimeLine = gsap.timeline({
      scrollTrigger: {
        trigger: wrapper,
        start: 'top top+=80%',
        end: 'bottom +=10%',
      },
    });

    titileTimeLine.fromTo(
      wrapper.find('.floating-box'),
      {
        y: '70px',
        opacity: 0,
      },
      {
        y: '0px',
        opacity: 1,
        stagger: 0.1,
      }
    );
  }

  $('.floating-wrapper').each(function () {
    SetFloatingBox($(this));
  });

  function SetMovingBox(wrapper, element, delay) {
    ScrollTrigger.create({
      trigger: wrapper,
      start: 'top top+=80%',
      end: 'bottom +=10%',
      onEnter: function () {
        setTimeout(function () {
          element.addClass('animated');
        }, delay * 1000);
      },
    });
  }

  $('.animate').each(function () {
    var delay = $(this).data('delay') ? $(this).data('delay') : 0;
    var wrapper = $(this).data('wrapper') ? $(this).data('wrapper') : $(this).closest('.animate-trigger');
    SetMovingBox(wrapper, $(this), delay);
  });

  /************** select 2 dropdown option formate ****************/
  function formatState(state) {
    if (!state.id) {
      return state.text;
    }
    var $state = $(
      '<span class="' +
        state.text
          .toLowerCase()
          .trim()
          .replace(/[^\w\s-]/g, '')
          .replace(/[\s_-]+/g, '-')
          .replace(/^-+|-+$/g, '') +
        '">' +
        state.text +
        '</span>'
    );
    return $state;
  }

  /************** Product Filter dropdown ****************/

  $('#FacetFiltersForm .tinyBot_dropdown, #FacetFiltersFormMobile .tinyBot_dropdown').select2({
    // placeholder: 'Your NULL value caption',
    // allowClear: true,  // Shows an X to allow the user to clear the value.
    minimumResultsForSearch: Infinity,
    templateResult: formatState,
  });

  $('#FacetFiltersForm .tinyBot_dropdown, #FacetFiltersFormMobile .tinyBot_dropdown').on(
    'select2:select select2:clear',
    function (e) {
      var evt = document.createEvent('HTMLEvents');
      evt.initEvent('input', false, true);
      $(this).closest('form')[0].dispatchEvent(evt);
      // console.log(this)
    }
  );

  /************* Product detail view**************/
  function initProductDetailView() {
    QuickViewProductSlider();
    $(document).on('click', '.description_readmore', toggleDiscription);
    $('.description_readmore').trigger('click');

    $('.product-form__input select').select2({
      // placeholder: 'Your NULL value caption',
      // allowClear: true,  // Shows an X to allow the user to clear the value.
      minimumResultsForSearch: Infinity,
      templateResult: formatState,
    });

    $('.product-form__input select').on('select2:select', function (e) {
      var evt = document.createEvent('HTMLEvents');
      evt.initEvent('change', false, true);
      $(this).closest('variant-selects')[0].dispatchEvent(evt);
      // console.log(this)
    });
  }

  function toggleDiscription(e) {
    if (typeof e != 'undefined') e.preventDefault();
    var el = $(this);
    var description = $(this).closest('.description');
    var description_wrapper = description.find('.description_wrapper');
    var description_wrapper_el = description_wrapper.find('*:first');
    var fullwidth = 0;
    description_wrapper.find('*').each(function () {
      // console.log(this, $(this).outerHeight(true))
      fullwidth += $(this).outerHeight(true);
    });
    if (description.hasClass('open')) {
      description_wrapper.animate({ height: description_wrapper_el.innerHeight() }, { queue: false, duration: 500 });
      description_wrapper.addClass('description_hidden');
      description.removeClass('open');
      el.text('Read more');
    } else {
      description_wrapper.animate({ height: fullwidth }, { queue: false, duration: 500 });
      description_wrapper.removeClass('description_hidden');
      description.addClass('open');
      el.text('Read less');
    }
  }

  function quickViewInit() {
    $(document).on('click', '.action-quickview', function (e) {
      e.preventDefault();
      let url = this.href;
      quickViewLoad(url);
    });
  }

  /* Product new slider */
  function QuickViewProductSlider() {
    var sync1 = $('.owl_sync1');
    var sync2 = $('.owl_sync2');
    var slidesPerPage = 6; //globaly define number of elements per page
    var syncedSecondary = true;

    sync1
      .owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: true,
        autoplay: false,
        dots: false,
        loop: true,
        responsiveRefreshRate: 200,
      })
      .on('changed.owl.carousel', syncPosition);

    sync2
      .on('initialized.owl.carousel', function () {
        sync2.find('.owl-item').eq(0).addClass('current');
      })
      .owlCarousel({
        items: slidesPerPage,
        dots: false,
        nav: false,
        margin: 0,
        smartSpeed: 200,
        slideSpeed: 500,
        slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
        responsiveRefreshRate: 100,
      })
      .on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
      //if you set loop to false, you have to restore this next line
      //var current = el.item.index;

      //if you disable loop you have to comment this block
      var count = el.item.count - 1;
      var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

      if (current < 0) {
        current = count;
      }
      if (current > count) {
        current = 0;
      }

      //end block

      sync2.find('.owl-item').removeClass('current').eq(current).addClass('current');
      var onscreen = sync2.find('.owl-item.active').length - 1;
      var start = sync2.find('.owl-item.active').first().index();
      var end = sync2.find('.owl-item.active').last().index();

      if (current > end) {
        sync2.data('owl.carousel').to(current, 100, true);
      }
      if (current < start) {
        sync2.data('owl.carousel').to(current - onscreen, 100, true);
      }
    }

    function syncPosition2(el) {
      if (syncedSecondary) {
        var number = el.item.index;
        sync1.data('owl.carousel').to(number, 100, true);
      }
    }

    sync2.on('click', '.owl-item', function (e) {
      e.preventDefault();
      var number = $(this).index();
      sync1.data('owl.carousel').to(number, 300, true);
    });
  }

  function quickViewLoad(url) {
    $.ajax({
      url: url,
      dataType: 'html',
      type: 'GET',
      beforeSend: () => {
        // vndHlp.showLoading();
      },
      success: function (data) {
        // vndHlp.hideLoading();
        $.magnificPopup.open({
          items: {
            src: '<div class="product-quick-view vnd-pp-content">' + data + '</div>', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline',
          },
          mainClass: 'mfp-appear-anm vnd-qv-pp',
          removalDelay: 350,
          fixedContentPos: true,
          fixedBgPos: true,
          callbacks: {
            open: function () {
              initProductDetailView();
              window.history &&
                window.history.pushState &&
                window.history.pushState({ page: 'quickview' }, 'quickviewed');
            },
            afterClose: function () {},
          },
        });
      },
      error: function () {
        console.log('Quick view error');
      },
    });
  }

  function initAccordian() {
    jQuery(document).on('click', '.accordion .accordion-item', function () {
      // Toggle the item
      if (jQuery(this).hasClass('is-active')) {
        jQuery('.accordion-item').removeClass('is-active').next('.accordion-panel').slideUp();
      } else {
        jQuery('.accordion-item').removeClass('is-active').next('.accordion-panel').slideUp();
        jQuery(this).addClass('is-active').next('.accordion-panel').slideDown();
      }
    });
  }

  if ($('.tinyBot_page_products_detail_wrap').length > 0) {
    initProductDetailView();
  }

  initAccordian();
  quickViewInit();

  //

  $('#articleSearchForm .tinyBot_dropdown, #resourceSearchForm .tinyBot_dropdown').select2({
    // placeholder: 'Your NULL value caption',
    allowClear: true, // Shows an X to allow the user to clear the value.
    minimumResultsForSearch: Infinity,
    templateResult: formatState,
  });

  // // Function to search, suggest, and filter blog articles by blog type, tags, and sorting
  // async function searchSuggestFilterAndSortBlogArticles(query, blogType, tags, sortKey, sortOrder) {
  //     const response = await fetch(`/search/suggest.json?q=${query}&resources[type]=article&resources[options][fields][article][]=title&resources[options][fields][article][]=url&resources[options][fields][article][]=published_at&resources[options][fields][article][]=author&resources[options][refinements][article][tags][]=${tags}&resources[options][refinements][article][blog_title][]=${blogType}&resources[options][sort_order]=${sortKey} ${sortOrder}`, {
  //         method: 'GET',
  //         headers: {
  //             'Content-Type': 'application/json',
  //         }
  //     });

  //     const result = await response.json();

  //     // Process the search results
  //     const articles = result.resources.results.articles;

  //     if (articles.length === 0) {
  //         console.log('No articles found.');
  //         return;
  //     }

  //     console.log(`Found ${articles.length} articles:`);
  //     articles.forEach(article => {
  //         const { title, url, published_at, author } = article;
  //         console.log(`- ${title}`);
  //         console.log(`  URL: ${url}`);
  //         console.log(`  Published: ${published_at}`);
  //         console.log(`  Author: ${author}`);
  //         console.log('------------------------');
  //     });
  // }

  // // Call the search function with a query, blog type, tags, sort key, and sort order
  // searchSuggestFilterAndSortBlogArticles('test', 'news', 'category 1', 'published_at', 'asc');

  // hover for top menu
  let items = document.querySelector('.header__inline-menu').querySelectorAll('details');
  // console.log(items)
  items.forEach((item) => {
    item.addEventListener('mouseover', () => {
      item.setAttribute('open', true);
      item.querySelector('ul').addEventListener('mouseleave', () => {
        item.removeAttribute('open');
      });
      item.addEventListener('mouseleave', () => {
        item.removeAttribute('open');
      });
    });
  });

  function stringToSlug(str) {
    // Convert the string to lowercase and replace spaces with hyphens
    const slug = str.toLowerCase().replace(/\s+/g, '-');

    // Remove special characters and non-alphanumeric characters except hyphens
    return slug.replace(/[^a-z0-9-]/g, '');
  }

  function convertToDateFormat(dateTimeString) {
    const dateObj = new Date(dateTimeString);
    const year = dateObj.getUTCFullYear().toString().slice(-2);
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getUTCDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
  }

  // blog search
  (function () {
    var searchForm = $('#articleSearchForm');

    var resultWrapper = $('#articleSearchResult');
    if (searchForm.length == 0) return;
    if (resultWrapper.length == 0) return;
    searchForm.on('submit', function (e) {
      e.preventDefault();
    });
    var search_data = { q: '', filter: '', sort: '', perpage: 19 };
    // const container = document.getElementById('infinite-scroll-container');
    let loading = false;
    var endpoint = 'https://tinybotvinyl.wolfmanapps.com/api/articles/news';
    var nextlink = endpoint; // Replace with the actual API endpoint to fetch more content

    function initSearch() {
      searchForm.find('select[name="filter"], select[name="sort"],input[name="q"]').change(function () {
        // search_data = { ...search_data, $(this).attr('id'): $(this).val() };
        search_data[$(this).attr('id')] = $(this).val();
        nextlink = endpoint;
        resultWrapper.html('');
        loadSearch();
      });

      // Attach the initial event listener to start infinite scrolling
      window.addEventListener('scroll', handleScroll);
      loadSearch();
    }

    function loadSearch() {
      if (loading) return;
      if (!nextlink) return;
      resultWrapper.addClass('loading');
      loading = true;
      $.get({
        url: nextlink,
        data: search_data,
        success: function (responce) {
          loading = false;
          if (responce.data.length === 0) {
            resultWrapper.append(`<div class="no-data-found">No data Found</div>`);
          }
          responce.data.forEach((blog, index) => {
            var tags = blog.tags.split(',');
            if (index === 10 && nextlink === endpoint) {
              resultWrapper.append(`<div class="events_grid_item">
                        <div class="exclusive_events">
                        <div class="featured_image">
                          <a href="/blogs/news/${blog.handle}">
                          ${blog.image ? `<img src="${blog.image.src}" alt=""/>` : ''}
                          </a>
                        </div>
                        ${tags[0] ? `<div class="tags ${stringToSlug(tags[0])}">${tags[0]}</div>` : ''}
                        <div class="h2"><a href="/blogs/news/${blog.handle}">${blog.title}</a></div></div>
                      </div>`);
            } else {
              resultWrapper.append(`<div class="events_grid_item">
                            <div class="featured_image">
                              <a href="/blogs/news/${blog.handle}">
                              ${blog.image ? `<img src="${blog.image.src}" alt=""/>` : ''}
                              </a>
                            </div>
                            ${tags[0] ? `<div class="tags ${stringToSlug(tags[0])}">${tags[0]}</div>` : ''}
                            <div class="h2"><a href="/blogs/news/${blog.handle}">${blog.title}</a></div>
                          </div>`);
            }
          });
          nextlink = responce.links.next;
          resultWrapper.removeClass('loading');
        },
      });
    }

    function handleScroll() {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const contentHeight = resultWrapper[0].clientHeight;

      // Load more content when the user is close to the bottom of the container
      if (scrollPosition + windowHeight >= contentHeight - 100) {
        loadSearch();
      }
    }

    initSearch();
  })();

  // academy search
  (function () {
    var resultWrapper = $('#academySearchResult');

    if (resultWrapper.length == 0) return;

    // const container = document.getElementById('infinite-scroll-container');
    let loading = false;
    var search_data = { perpage: 13 };
    var endpoint = 'https://tinybotvinyl.wolfmanapps.com/api/articles/academy';
    var nextlink = endpoint;
    function initSearch() {
      loadSearch();
      window.addEventListener('scroll', handleScroll);
    }
    function loadSearch() {
      if (loading) return;
      if (!nextlink) return;
      resultWrapper.addClass('loading');
      loading = true;
      $.get({
        url: nextlink,
        data: search_data,
        success: function (responce) {
          loading = false;
          if (responce.data.length === 0) {
            resultWrapper.append(`<div class="no-data-found">No academy Found</div>`);
          }
          responce.data.forEach((blog, index) => {
            var tags = blog.tags.split(',');
            if (index === 0 && nextlink === endpoint) {
              resultWrapper.append(`<div class="events_grid_item">
<div class="tinyBot_beginner_calass_wrap">
  <div class="featured_image object-fit">
  ${blog.image ? `<img src="${blog.image.src}" alt=""/>` : ''}
  </div>
  <div class="basic_beginner_class">
    <div class="date_col">
      <div class="date">${convertToDateFormat(blog.created_at)}</div>
    </div>
    <div class="context_col">
      <div class="big_title">${blog.title}</div>
      <div class="cta_button_wrap outline">
        <a href="/blogs/academy/${blog.handle}">
          <span class="cta_text">SIGN UP NOW</span>
          <span class="cta_button">
            <i></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</div>
</div>`);
            } else {
              resultWrapper.append(`<div class="events_grid_item">
                            <div class="featured_image">
                              <a href="/blogs/academy/${blog.handle}">
                              ${blog.image ? `<img src="${blog.image.src}" alt=""/>` : ''}
                              </a>
                            </div>
                            ${tags[0] ? `<div class="tags new">${stringToSlug(tags[0])}</div>` : ''}
                            <div class="h2"><a href="/blogs/academy/${blog.handle}">${blog.title}</a></div>
                          </div>`);
            }
            nextlink = responce.links.next;
            resultWrapper.removeClass('loading');
          });
        },
      });
    }

    function handleScroll() {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const contentHeight = resultWrapper[0].clientHeight;

      // Load more content when the user is close to the bottom of the container
      if (scrollPosition + windowHeight >= contentHeight - 100) {
        loadSearch();
      }
    }
    initSearch();
  })();

  // resource search
  // (function () {
  //     var searchForm = $('#resourceSearchForm');
  //     var resultWrapper = $('#resourceSearchResult');
  //     if (searchForm.length == 0) return;
  //     if (resultWrapper.length == 0) return;
  //     searchForm.on('submit', function (e) {
  //         e.preventDefault();
  //     })
  //     var search_data = { q: "", filter: '', sort: '', perpage: 17 }
  //     // const container = document.getElementById('infinite-scroll-container');
  //     let loading = false;
  //     var endpoint = 'https://tinybotvinyl.wolfmanapps.com/api/search/resource';
  //     var nextlink = endpoint; // Replace with the actual API endpoint to fetch more content

  //     function initSearch() {
  //         searchForm.find('select[name="filter"], select[name="sort"],input[name="q"]').change(function () {
  //             // search_data = { ...search_data, $(this).attr('id'): $(this).val() };
  //             search_data[$(this).attr('id')] = $(this).val();
  //             nextlink = endpoint;
  //             resultWrapper.html('')
  //             loadSearch();
  //         })

  //         // Attach the initial event listener to start infinite scrolling
  //         window.addEventListener('scroll', handleScroll);
  //         loadSearch();
  //     }

  //     function loadSearch() {
  //         if (loading) return;
  //         if (!nextlink) return;
  //         resultWrapper.addClass('loading')
  //         loading = true;
  //         $.get({
  //             url: nextlink,
  //             data: search_data,
  //             success: function (responce) {
  //                 loading = false;
  //                 if (responce.data.length === 0) {
  //                     resultWrapper.append(`<div class="no-data-found">No resource Found</div>`)
  //                 }
  //                 responce.data.forEach((blog, index) => {
  //                     // console.log(blog.featured)
  //                     var category = blog.category.split(",")
  //                     if (blog.featured === 1) {
  //                         var sub_name = [];
  //                         if (blog.resource_sub_name) {
  //                             sub_name = blog.resource_sub_name.split(' ');
  //                         }

  //                         resultWrapper.append(`<div class="events_grid_item resource_item featured">
  //                         <div class="tinyBot_measurement_wrap">
  //                           ${sub_name[0] ? `<div class="tbm_text_1">${sub_name[0]}</div>` : ``}
  //                           ${sub_name[1] ? `<div class="tbm_text_2">${sub_name[1]}</div>` : ``}
  //                           <div class="tinyBot_measurement_block">
  //                            ${blog.external_link ? ` <a href="${blog.external_link}" target="_blank" rel="nofollow">` : ""}
  //                             <div class="featured_image object-fit">
  //                             ${blog.image ? `<img src="${blog.image}" alt=""/>` : ''}
  //                             </div>
  //                             ${blog.external_link ? `</a>` : ``}
  //                             <div class="text_over_image">
  //                             ${category[0] ? `<div class="tags">${stringToSlug(category[0])}</div>` : ''}
  //                               <div class="big_title">
  //                               ${blog.external_link ? ` <a href="${blog.external_link}" target="_blank" rel="nofollow">` : ""}
  //                               ${blog.resource_name}
  //                               ${blog.external_link ? `</a>` : ``}
  //                               </div>
  //                             </div>
  //                           </div>
  //                         </div>
  //                       </div>`)
  //                     } else {
  //                         resultWrapper.append(`<div class="events_grid_item resource_item">
  //                         ${blog.external_link ? ` <a href="${blog.external_link}" target="_blank" rel="nofollow">` : ""}
  //                         <div class="featured_image">
  //                         ${blog.image ? `<img src="${blog.image}" alt=""/>` : ''}
  //                         </div>
  //                         ${blog.external_link ? `</a>` : ``}
  //                         ${category[0] ? `<div class="tags new">${stringToSlug(category[0])}</div>` : ''}
  //                         <div class="h2">
  //                         ${blog.external_link ? ` <a href="${blog.external_link}" target="_blank" rel="nofollow">` : ""}
  //                         ${blog.resource_name}
  //                         ${blog.external_link ? `</a>` : ``}
  //                         </div>
  //                       </div>`)
  //                     }
  //                 })
  //                 nextlink = responce.links.next;
  //                 resultWrapper.removeClass('loading')
  //             }
  //         })
  //     }

  //     function handleScroll() {
  //         const scrollPosition = window.scrollY;
  //         const windowHeight = window.innerHeight;
  //         const contentHeight = resultWrapper[0].clientHeight;

  //         // Load more content when the user is close to the bottom of the container
  //         if (scrollPosition + windowHeight >= contentHeight - 100) {
  //             loadSearch();
  //         }
  //     }

  //     initSearch()
  // })();

  (function () {
    var searchForm = $('#resourceSearchForm');
    var resultWrapper = $('#resourceSearchResult');
    if (searchForm.length == 0) return;
    if (resultWrapper.length == 0) return;
    searchForm.on('submit', function (e) {
      e.preventDefault();
    });
    var search_data = { q: '', filter: '', sort: '', perpage: 17 };
    // const container = document.getElementById('infinite-scroll-container');
    let loading = false;
    var endpoint = 'https://tinybotvinyl.wolfmanapps.com/api/articles/resource';
    var nextlink = endpoint; // Replace with the actual API endpoint to fetch more content

    function initSearch() {
      searchForm.find('select[name="filter"], select[name="sort"],input[name="q"]').change(function () {
        // search_data = { ...search_data, $(this).attr('id'): $(this).val() };
        search_data[$(this).attr('id')] = $(this).val();
        nextlink = endpoint;
        resultWrapper.html('');
        loadSearch();
      });

      // Attach the initial event listener to start infinite scrolling
      window.addEventListener('scroll', handleScroll);
      loadSearch();
    }

    function loadSearch() {
      if (loading) return;
      if (!nextlink) return;
      resultWrapper.addClass('loading');
      loading = true;
      $.get({
        url: nextlink,
        data: search_data,
        success: function (responce) {
          loading = false;
          if (responce.data.length === 0) {
            resultWrapper.append(`<div class="no-data-found">No resource Found</div>`);
          }
          responce.data.forEach((blog, index) => {
            // console.log(blog.featured)
            var tags = blog.tags.split(', ');

            if (tags.includes('featured')) {
              //remove featured from tag list
              var fetauredindex = tags.indexOf('featured');
              if (fetauredindex > -1) {
                tags.splice(fetauredindex, 1);
              }

              //derive subtitle from tag

              var sub_name = [];
              var subTitle = tags.find((tag) => tag.includes('sub_title_'));
              var subTitleIndex = tags.indexOf(subTitle);
              if (subTitleIndex > -1) {
                tags.splice(subTitleIndex, 1);
                sub_name = subTitle.replace('sub_title_', '').split('_');
                console.log(sub_name);
              }

              resultWrapper.append(`<div class="events_grid_item resource_item featured">
                            <div class="tinyBot_measurement_wrap">
                              ${sub_name[0] ? `<div class="tbm_text_1">${sub_name[0]}</div>` : ``}
                              ${sub_name[1] ? `<div class="tbm_text_2">${sub_name[1]}</div>` : ``}
                              <div class="tinyBot_measurement_block">
                               ${blog.handle ? ` <a href="/blogs/resource/${blog.handle}" >` : ''}
                                <div class="featured_image object-fit">
                                ${blog.image ? `<img src="${blog.image.src}" alt=""/>` : ''}
                                </div>
                                ${blog.handle ? `</a>` : ``}
                                <div class="text_over_image">
                                ${tags[0] ? `<div class="tags">${stringToSlug(tags[0])}</div>` : ''}
                                  <div class="big_title">
                                  ${blog.handle ? ` <a href="/blogs/resource/${blog.handle}" >` : ''}
                                  ${blog.title}
                                  ${blog.handle ? `</a>` : ``}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>`);
            } else {
              resultWrapper.append(`<div class="events_grid_item resource_item">
                            ${blog.handle ? ` <a href="/blogs/resource/${blog.handle}" >` : ''}
                            <div class="featured_image">
                            ${blog.image ? `<img src="${blog.image.src}" alt=""/>` : ''}
                            </div>
                            ${blog.handle ? `</a>` : ``}
                            ${tags[0] ? `<div class="tags new">${stringToSlug(tags[0])}</div>` : ''}
                            <div class="h2">
                            ${blog.handle ? ` <a href="/blogs/resource/${blog.handle}" >` : ''}
                            ${blog.title}
                            ${blog.handle ? `</a>` : ``}
                            </div>
                          </div>`);
            }
          });
          nextlink = responce.links.next;
          resultWrapper.removeClass('loading');
        },
      });
    }

    function handleScroll() {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const contentHeight = resultWrapper[0].clientHeight;

      // Load more content when the user is close to the bottom of the container
      if (scrollPosition + windowHeight >= contentHeight - 100) {
        loadSearch();
      }
    }

    initSearch();
  })();

  // stores search
  // (function () {

  //     var searchForm = $('#shopSearchForm');
  //     var resultWrapper = $('#shop_partners_list');
  //     if (searchForm.length == 0) return;
  //     if (resultWrapper.length == 0) return;
  //     var search_data = { q: "", filter: '', sort: '', perpage: 50 }
  //     // const container = document.getElementById('infinite-scroll-container');
  //     let loading = false;
  //     var endpoint = 'https://tinybotvinyl.wolfmanapps.com/api/search/stores';
  //     var nextlink = endpoint; // Replace with the actual API endpoint to fetch more content

  //     function initSearch() {
  //         searchForm.find('select[name="filter"], select[name="sort"],input[name="q"]').change(function () {
  //             // search_data = { ...search_data, $(this).attr('id'): $(this).val() };
  //             search_data[$(this).attr('id')] = $(this).val();
  //             nextlink = endpoint;
  //             resultWrapper.html('')
  //             loadSearch();
  //         })

  //         // Attach the initial event listener to start infinite scrolling
  //         window.addEventListener('scroll', handleScroll);
  //         loadSearch();
  //     }
  //     // shop_partners_list
  //     function loadSearch() {
  //         if (loading) return;
  //         if (!nextlink) return;
  //         resultWrapper.addClass('loading')
  //         loading = true;
  //         $.get({
  //             url: nextlink,
  //             data: search_data,
  //             success: function (responce) {
  //                 loading = false;

  //                 responce.data.forEach((stor, index) => {
  //                     resultWrapper.append(`
  //                         <div class="item">
  //                         <div class="icon">
  //                           <svg width="18" height="25" viewBox="0 0 18 25" fill="none"><path d="M7.875 23.8116C5.4375 20.7647 0 13.4991 0 9.37405C0 4.4053 3.98438 0.374054 9 0.374054C13.9688 0.374054 18 4.4053 18 9.37405C18 13.4991 12.5156 20.7647 10.0781 23.8116C9.51562 24.5147 8.4375 24.5147 7.875 23.8116ZM9 12.3741C10.6406 12.3741 12 11.0616 12 9.37405C12 7.73343 10.6406 6.37405 9 6.37405C7.3125 6.37405 6 7.73343 6 9.37405C6 11.0616 7.3125 12.3741 9 12.3741Z" fill="#EA3223"></path></svg>
  //                         </div>
  //                         <div class="content">
  //                           ${stor.store_name ? `<h2>${stor.store_name}</h2>` : ``}
  //                           ${stor.address ? `<p>${stor.address}</p>` : ``}
  //                           ${stor.email ? `<p>${stor.email}</p>` : ``}
  //                           ${stor.phone ? `<p>${stor.phone}</p>` : ``}
  //                         </div>
  //                       </div>
  //                  `)

  //                 })
  //                 nextlink = responce.links.next;
  //                 resultWrapper.removeClass('loading')
  //             }
  //         })
  //     }

  //     function handleScroll() {
  //         const scrollPosition = window.scrollY;
  //         const windowHeight = window.innerHeight;
  //         const contentHeight = resultWrapper[0].clientHeight;

  //         // Load more content when the user is close to the bottom of the container
  //         if (scrollPosition + windowHeight >= contentHeight - 100) {
  //             loadSearch();
  //         }
  //     }
  //     initSearch()
  // })()

  // map location
});
